import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spmb-alih"
}
const _hoisted_2 = {
  class: "spmb-alih__panel",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "spmb-alih-judul"
}
const _hoisted_3 = { class: "spmb-alih__alamat" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  class: "spmb-alih__hitung",
  role: "status"
}
const _hoisted_6 = { class: "spmb-alih__detik" }
const _hoisted_7 = ["href"]

import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";

const JEDA_DETIK = 5;


export default /*@__PURE__*/_defineComponent({
  __name: 'SpmbRedirectPopup',
  setup(__props) {

const HOST_BARU: Record<string, string> = {
  "ppdb-admin.teknologikartu.com": "spmb-admin.teknologikartu.com",
  // "localhost": "spmb-admin.teknologikartu.com",
};
const hostBaru = HOST_BARU[window.location.hostname];
const urlRoot = hostBaru ? `https://${hostBaru}/` : "";

const detik = ref(JEDA_DETIK);
const tombol = ref<HTMLElement | null>(null);

let timer: number | undefined;
let overflowSebelumnya: string | null = null;

const hentikanTimer = () => {
  if (timer !== undefined) {
    window.clearInterval(timer);
    timer = undefined;
  }
};

const alihkan = () => {
  hentikanTimer();
  const { pathname, search, hash } = window.location;
  window.location.replace(`https://${hostBaru}${pathname}${search}${hash}`);
};

onMounted(() => {
  if (!hostBaru) return;

  overflowSebelumnya = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  nextTick(() => tombol.value?.focus());

  timer = window.setInterval(() => {
    detik.value -= 1;
    if (detik.value <= 0) alihkan();
  }, 1000);
});

onBeforeUnmount(() => {
  hentikanTimer();
  if (overflowSebelumnya !== null) {
    document.body.style.overflow = overflowSebelumnya;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(hostBaru))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "spmb-alih__label" }, "PEMBERITAHUAN UNTUK ADMIN SEKOLAH", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("h1", {
              id: "spmb-alih-judul",
              class: "spmb-alih__judul"
            }, [
              _createElementVNode("span", { class: "spmb-alih__lama" }, [
                _createElementVNode("s", { class: "spmb-alih__coret" }, "PPDB"),
                _createTextVNode(" kini menjadi")
              ]),
              _createElementVNode("span", { class: "spmb-alih__baru" }, "SPMB")
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "spmb-alih__kepanjangan" }, "Sistem Penerimaan Murid Baru", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "spmb-alih__penjelasan" }, " Istilah PPDB pada aplikasi admin ini berubah menjadi SPMB, menyesuaikan Permendikdasmen Nomor 3 Tahun 2025. Alamat aplikasi ikut berubah. ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "spmb-alih__alamat-judul" }, "Alamat baru", -1)),
              _createElementVNode("a", {
                class: "spmb-alih__tujuan",
                href: _unref(urlRoot),
                onClick: _withModifiers(alihkan, ["prevent"])
              }, _toDisplayString(_unref(hostBaru)), 9, _hoisted_4),
              _createElementVNode("p", _hoisted_5, [
                _cache[0] || (_cache[0] = _createTextVNode(" Anda akan dialihkan otomatis dalam ", -1)),
                _createElementVNode("strong", _hoisted_6, _toDisplayString(detik.value), 1),
                _cache[1] || (_cache[1] = _createTextVNode(" detik. ", -1))
              ]),
              _createElementVNode("a", {
                ref_key: "tombol",
                ref: tombol,
                class: "spmb-alih__tombol",
                href: _unref(urlRoot),
                onClick: _withModifiers(alihkan, ["prevent"])
              }, "Buka sekarang", 8, _hoisted_7),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "spmb-alih__info" }, " Login tetap menggunakan akun yang sama: username dan kata sandi Anda tidak berubah. ", -1))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "spmb-alih__footer" }, [
              _createElementVNode("img", {
                class: "spmb-alih__logo",
                src: "/media/logos/logo-tki-putih.svg",
                alt: "Teknologi Kartu Indonesia"
              }),
              _createElementVNode("p", { class: "spmb-alih__dasar" }, "Dasar: Permendikdasmen No. 3 Tahun 2025")
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})